import React from 'react';
import PropTypes from 'prop-types';

// Mixins / Modules
import { isEmptyObject } from '../../../../../../modules/global';

// Models
import TechnologyCategory from '../../../../../../models/v2/technology_category';

// Base
import Badge from '../../../../base/badge';
import Card from '../../../../base/card';
import Col from '../../../../base/col';
import Row from '../../../../base/row';

// Related Components
import Loading from './technical_expertise/loading';

export default class TechnicalExpertise extends React.Component {
  static propTypes = {
    user: PropTypes.object.isRequired,
    profile: PropTypes.object.isRequired,
    persona: PropTypes.object.isRequired,
  }

  state = {
    loading: true,
    selectedTechnicalCategories: [],
  }

  componentDidMount() {
    const { profile, persona } = this.props;
    if (isEmptyObject(persona) && (profile.technology_category_ids || []).length > 0) {
      // For all personas
      TechnologyCategory
        .where({ id_in: profile.technology_category_ids})
        .sort('name ASC')
        .all(false)
        .then((selectedTechnicalCategories) => {
          this.setState({
            loading: false,
            selectedTechnicalCategories,
          })
        })
    } else if (!isEmptyObject(persona) && (persona.technology_category_ids || []).length > 0) {
      // For a specific persona
      TechnologyCategory
        .where({ id_in: persona.technology_category_ids })
        .sort('name ASC')
        .all(false)
        .then((selectedTechnicalCategories) => {
          this.setState({
            loading: false,
            selectedTechnicalCategories,
          })
        })
    } else {
      this.setState({
        loading: false,
        selectedTechnicalCategories: [],
      })
    }
  }

  render() {
    const { loading, selectedTechnicalCategories } = this.state;

    if (loading) {
      return <Loading />
    }

    return (
      <Card
        border='none'
        className='min-height-80'
        noPadding
      >
        <Row className='margin-top-15 margin-bottom-10' nested>
          <Col s={12} className='med-font dark margin-bottom-10'>
            Technical Expertise
          </Col>
          <Col s={12}>
            {
              selectedTechnicalCategories.map((category) => (
                <Badge
                  key={category.id}
                  text={category.name}
                />
              ))
            }
            {
              selectedTechnicalCategories.length === 0 &&
              <div className='gray-900'>None Selected</div>
            }
          </Col>
        </Row>
      </Card>
    )
  }
}